import { writable, type Writable } from "svelte/store"

export type AbTestingStoreType = {
  runningExperiments: Record<string, string>
}
/** Keeps track of the AB tests that are running */
const abTesting: Writable<AbTestingStoreType> = writable({
  runningExperiments: {},
})

export default abTesting
